import type { JSONConfig } from '@/engine/app/interfaces.ts';
import { SlicerMode, SliceType } from '@/engine/app/modules/images/interfaces.ts';

export const axial: JSONConfig.ImageSlice = {
  descriptor: SliceType.AXIAL,
  label: 'AXIAL image',
  color: '#FF0000',
  borderColor: '#e00000',
  isVisible: false,
  imageSlicerMode: SlicerMode.SINGLE
};

export const coronal: JSONConfig.ImageSlice = {
  descriptor: SliceType.CORONAL,
  label: 'CORONAL image',
  color: '#00FF00',
  borderColor: '#6cbf62',
  isVisible: false,
  imageSlicerMode: SlicerMode.SINGLE
};

export const sagittal: JSONConfig.ImageSlice = {
  descriptor: SliceType.SAGITTAL,
  label: 'SAGITTAL image',
  color: '#0000FF',
  borderColor: ' #0049ef',
  isVisible: false,
  imageSlicerMode: SlicerMode.SINGLE
};
